/**
 * C4: the signature soft asymmetric curve. Our own path: high on the left,
 * lowest a little left of centre, easing to nearly flat at the right edge.
 * Absolutely positioned at the bottom of its (position: relative) parent and
 * filled with the colour of the section that follows (white by default).
 *
 *   <section className="ve-photo-hero"> ... <CurveDivider /> </section>
 *   <CurveDivider color="var(--c-surface)" flip />   // top edge of a grey band
 */
export interface CurveDividerProps {
  /** Fill colour (any CSS colour or var()). Default: white. */
  color?: string;
  /** Mirror vertically for use at the top of a section. */
  flip?: boolean;
  /** Render in flow (relative) instead of absolute at the parent's bottom. */
  inFlow?: boolean;
  className?: string;
}

// viewBox 0 0 1440 80; the fill is everything under the curve line.
const PATH = 'M0 66 C 210 66 360 8 610 8 C 880 8 1150 52 1440 58 L1440 80 L0 80 Z';

export default function CurveDivider({ color, flip = false, inFlow = false, className = '' }: CurveDividerProps) {
  const cls = ['ve-curve', flip ? 've-curve--flip' : '', inFlow ? 've-curve--static' : '', className].filter(Boolean).join(' ');
  return (
    <div className={cls} aria-hidden="true" style={color ? { color } : undefined}>
      <svg viewBox="0 0 1440 80" preserveAspectRatio="none" focusable="false">
        <path d={PATH} fill="currentColor" />
      </svg>
    </div>
  );
}
